import {AnalyticsTrackerPlugin} from "FirebaseUtils";

class ActivityAnalyticsService {
  static Event = {
    ACTIVITY_DETAILS_VIEWED: "Activity Details Viewed",
    ACTIVITY_DETAILS_EDITED: "Activity Details Edited",
    ACTIVITY_DELETED: "Activity Deleted",
    ACTIVITY_TRIMMED_CROPPED: "Activity Trimmed/Cropped",
    ACTIVITY_PHOTO_ADDED: "Activity Photo Added",
    GPX_IMPORTED: "GPX Imported",
    FIT_IMPORTED: "FIT Imported",
    VKX_IMPORTED: "VKX Imported",
    DEMO_ACTIVITY_OPENED: "Demo activity opened",
    EQUIP_PAGE_OPENED: "Equip page opened"
  };

  static async trackActivityDetailsViewed(id: string, sportType: string) {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.ACTIVITY_DETAILS_VIEWED,
      properties: {
        id: id,
        sport_type: sportType
      }
    });
  }

  static async trackEquipPageOpened() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.EQUIP_PAGE_OPENED
    });
  }

  static async trackActivityDetailsEdited() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.ACTIVITY_DETAILS_EDITED
    });
  }

  static async trackActivityDeleted() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.ACTIVITY_DELETED
    });
  }

  static async trackActivityTrimmedCropped() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.ACTIVITY_TRIMMED_CROPPED
    });
  }

  static async trackActivityPhotoAdded(activityId: string, photoCount: number = 1) {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.ACTIVITY_PHOTO_ADDED,
      properties: {
        activity_id: activityId,
        photo_count: photoCount
      }
    });
  }

  static async trackGpxImported() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.GPX_IMPORTED
    });
  }

  static async trackFitImported() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.FIT_IMPORTED
    });
  }

  static async trackVkxImported() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.VKX_IMPORTED
    });
  }

  static async trackDemoActivityOpened() {
    await AnalyticsTrackerPlugin.trackEvent({
      eventName: this.Event.DEMO_ACTIVITY_OPENED
    });
  }
}

export default ActivityAnalyticsService;
